"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PdfCharacterPropertiesExporter = void 0;
var color_1 = require("../core/model/color/color");
var color_2 = require("@devexpress/utils/lib/utils/color");
var PdfCharacterPropertiesExporter = (function () {
    function PdfCharacterPropertiesExporter() {
    }
    PdfCharacterPropertiesExporter.prototype.exportCharacterProperties = function (doc, box, pos, size, needUnderlineAndStrikeout) {
        var colorProps = box.colorInfo;
        var textColor = colorProps.textColor;
        var foregroundColor = colorProps.foregroundColor;
        if (box.hyperlinkTip)
            doc.link(pos.x, pos.y, size.width, size.height, box.hyperlinkTip);
        if (foregroundColor != color_1.ColorHelper.AUTOMATIC_COLOR) {
            doc.save();
            doc.rect(pos.x, pos.y + 1, size.width, size.height - 2).fill(color_2.ColorUtils.colorToHash(foregroundColor));
            doc.restore();
        }
        if (textColor == color_1.ColorHelper.AUTOMATIC_COLOR)
            textColor = color_1.ColorHelper.BLACK_COLOR;
        doc.fillColor(color_2.ColorUtils.colorToHash(textColor));
        if (needUnderlineAndStrikeout && box.characterProperties.fontStrikeoutType && box.characterProperties.fontUnderlineType)
            doc.strike(pos.x, pos.y, size.width, size.height, { color: color_2.ColorUtils.colorToHash(textColor) });
    };
    return PdfCharacterPropertiesExporter;
}());
exports.PdfCharacterPropertiesExporter = PdfCharacterPropertiesExporter;
